// Footer intentionally left empty for new implementation.
// You can reuse this file to build your new footer.

import React from 'react';

const socials = [
  { name: 'X', url: 'https://x.com' },
  { name: 'LinkedIn', url: 'https://linkedin.com' },
  { name: 'GitHub', url: 'https://github.com' },
  { name: 'Instagram', url: 'https://www.instagram.com/zeoqo_/' },
];

const navLinks = [
  { name: 'Home', url: '/' },
  { name: 'Services', url: '/services' },
  { name: 'Showcase', url: '/teams#projects' },
  { name: 'People', url: '/teams#squad' },
  { name: 'Blog', url: '/blog' },
  { name: 'Lab', url: '/teams#lab' },
  { name: 'Contact Us', url: '/contact' },
  { name: 'Privacy Policy', url: '/privacy' },
];

type FooterProps = {
  onNavigate: (page: 'home' | 'services' | 'teams' | 'contact' | 'privacy', anchor?: string) => void;
  currentPage: 'home' | 'services' | 'teams' | 'contact' | 'privacy';
    };

const Footer: React.FC<FooterProps> = ({ onNavigate, currentPage }) => (
  <footer className="w-full bg-black text-white flex flex-col items-stretch pt-0 pb-0 min-h-[60vh]">
    {/* Huge Brand Bar */}
    <div className="w-full text-[12vw] md:text-[8vw] font-black tracking-tight leading-none px-4 md:px-12 pt-8 pb-0" style={{fontFamily: 'Orbitron, Anton, Inter, sans-serif', letterSpacing: '-0.04em'}}>
      ZEOQO
    </div>
    {/* Main Content */}
    <div className="flex flex-col md:flex-row w-full flex-1 px-4 md:px-12 pt-0 pb-0 gap-0 md:gap-0">
      {/* Left: Newsletter & Description */}
      <div className="flex-1 flex flex-col justify-end pb-12 md:pb-24">
        <p className="text-lg text-gray-300 mb-6">Ready to tap into the Zeoqo vibe? Sign up for our newsletter and stay plugged into all the cool stuff we're cooking up.</p>
        <form className="flex flex-col md:flex-row gap-2 md:gap-4 max-w-md">
          <input type="email" placeholder="Enter your Email" className="bg-black border border-gray-700 text-white px-4 py-2 text-base w-full md:w-auto focus:outline-none focus:border-white placeholder-gray-500" />
          <button type="submit" className="bg-white text-black px-6 py-2 font-bold text-base hover:bg-gray-200 transition">Roll Me In →</button>
        </form>
          </div>
      {/* Right: Vertical Nav */}
      <div className="flex-1 flex flex-col items-end justify-end pb-12 md:pb-24">
        <nav className="flex flex-col items-end gap-2 md:gap-3">
          {navLinks.map(link => {
            if (link.url === '/') {
              return (
                <button key={link.name} onClick={() => onNavigate('home')} className="text-2xl md:text-4xl font-bold hover:underline text-white bg-transparent border-none p-0 m-0" style={{fontFamily: 'Inter, sans-serif', cursor: 'pointer'}}>
                  {link.name}
                </button>
              );
            }
            if (link.url === '/services') {
              return (
                <button key={link.name} onClick={() => onNavigate('services')} className="text-2xl md:text-4xl font-bold hover:underline text-white bg-transparent border-none p-0 m-0" style={{fontFamily: 'Inter, sans-serif', cursor: 'pointer'}}>
                  {link.name}
                </button>
              );
            }
            if (link.url === '/contact') {
              return (
                <button key={link.name} onClick={() => onNavigate('contact')} className="text-2xl md:text-4xl font-bold hover:underline text-white bg-transparent border-none p-0 m-0" style={{fontFamily: 'Inter, sans-serif', cursor: 'pointer'}}>
                  {link.name}
                </button>
              );
            }
            if (link.url === '/privacy') {
              return (
                <button key={link.name} onClick={() => onNavigate('privacy')} className="text-2xl md:text-4xl font-bold hover:underline text-white bg-transparent border-none p-0 m-0" style={{fontFamily: 'Inter, sans-serif', cursor: 'pointer'}}>
                  {link.name}
                      </button>
              );
            }
            if (link.url.startsWith('/teams#')) {
              const anchor = link.url.split('#')[1];
              return (
                <button key={link.name} onClick={() => onNavigate('teams', anchor)} className="text-2xl md:text-4xl font-bold hover:underline text-white bg-transparent border-none p-0 m-0" style={{fontFamily: 'Inter, sans-serif', cursor: 'pointer'}}>
                  {link.name}
                      </button>
              );
            }
            // Blog and external links
            return (
              <a key={link.name} href={link.url} className="text-2xl md:text-4xl font-bold hover:underline text-white" style={{fontFamily: 'Inter, sans-serif'}}>
                {link.name}
              </a>
            );
          })}
        </nav>
                  </div>
                </div>
    {/* Bottom Bar */}
    <div className="w-full flex flex-col md:flex-row justify-between items-end md:items-center px-4 md:px-12 py-4 border-t border-gray-800 bg-black text-xs md:text-sm" style={{fontFamily: 'Inter, JetBrains Mono, monospace'}}>
      <div className="flex flex-row gap-4 md:gap-6 text-gray-400">
        {socials.map(s => (
          <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" className="hover:text-white transition">
            {s.name}
          </a>
        ))}
            </div>
      <div className="text-gray-500 mt-2 md:mt-0">© hello@digitaldreams.com 2025 all rights reserved</div>
          </div>
  </footer>
  );

export default Footer; 